import { useQuery } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';
import { HOOKS_SETTINGS } from '../constants';

const { CONTROLLERS: { ESTIMATED_TAX_RATE: { BASE, VERSION } } } = USER;
const { METHOD: { POST } } = HOOKS_SETTINGS;

export const useTaxBucketSetPercentAndActivate = ({
  customerId, activate = true, savePercent, onSuccess,
}: { customerId: string, activate?: boolean, savePercent: number, onSuccess?: () => void, }) => useQuery(
  'tax-bucket-setup-activate',
  async () => {
    if (!customerId || savePercent === undefined) {
      return null;
    }
    const { data } = await httpService({
      url: `${BASE_URL}/api/${VERSION}/user/${customerId}/${BASE}`,
      method: POST,
      data: {
        savePercent,
        activate,
      },
    });
    return data;
  },
  {
    enabled: false,
    onSuccess: () => { if (onSuccess) onSuccess(); },
  },
);
